// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"b56b7235","318":"1a09a4bb","423":"d10b9ece"}[chunkId] + ".chunk.js";
};